import { MenuItemData } from '@/data/menuData'
import { ChevronDown } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useViewMode } from '@/stores/viewMode'
import { useMyPermissions } from '@/hooks/useMyPermissions'
import { useMe } from '@/hooks/useMe'
// Submenu children reuse the SAME gate as top-level items (incl. exactPermission /
// hierarchical), so nested role items can never diverge from the sidebar. There used
// to be a copy-pasted clone here that had drifted (it referenced a non-existent
// `hideInModes` field and lacked the strict role gate).
import { filterMenuItem } from './filterMenuItem'

interface MenuItem {
  item: MenuItemData
  onClose?: () => void
}

export default function MenuItem({ item, onClose }: MenuItem) {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(true) // Changed from false to true to make submenus open by default
  const { mode } = useViewMode()
  const { hasPermission } = useMyPermissions()
  const { user } = useMe()

  const handleClick = () => {
    if (item.children) {
      setIsOpen(!isOpen)
    } else {
      item.onClick(navigate)
      // 在移動端點擊菜單項後關閉側邊欄
      onClose?.()
    }
  }

  // Filter children based on permissions, scopes and mode
  const userRoleType = user?.role_type
  const userScopes = user?.scopes
  const filteredChildren = item.children
    ? item.children.filter((child) =>
        filterMenuItem(child, hasPermission, userRoleType, userScopes, mode),
      )
    : []

  return (
    <li className="mb-1">
      <button
        onClick={handleClick}
        className="group flex items-center w-full px-3 py-4 text-sm font-medium text-[#898989] rounded-md hover:bg-gray-200 focus:outline-none"
      >
        <item.icon className="w-4 h-4 mr-2 stroke-[#898989] group-hover:stroke-gray-700" />
        {item.label}
        {item.children && filteredChildren.length > 0 && (
          <ChevronDown
            className={`w-4 h-4 ml-auto stroke-[#898989] group-hover:stroke-gray-700 transition-transform ${isOpen ? 'transform rotate-180' : ''}`}
          />
        )}
      </button>
      {item.children && isOpen && filteredChildren.length > 0 && (
        <ul className="pl-6 mt-1">
          {filteredChildren.map((child) => (
            <li key={child.label} className="mb-1">
              <button
                onClick={() => {
                  child.onClick(navigate)
                  // 在移動端點擊子菜單項後關閉側邊欄
                  onClose?.()
                }}
                className="group flex items-center w-full px-3 py-3 text-sm font-medium text-[#898989] rounded-md hover:bg-gray-200 focus:outline-none"
              >
                <child.icon className="w-4 h-4 mr-2 stroke-[#898989] group-hover:stroke-gray-700" />
                {child.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}
